<template>
	<div class="login layui-layout layui-layout-admin">
		<div class="layui-header zt_color layui-row f_row al_itm jc_ct">
			<div class="px24" style="color:#fff;">
				{{types == 1 ? '注册': '忘记密码'}}
			</div>
		</div>
		<div class="logo">
			<img src="../assets/logo.png" />
		</div>
		<div class="layui-form rgBoxs" action="">
			<div class="layui-form-item">
				<label class="layui-form-label">手机号码</label>
				<div class="layui-input-block">
					<input type="phone" maxlength="11" v-model="phones" name="phones" required lay-verify="phone" placeholder="手机号码将作为登录的账号" autocomplete="off" class="layui-input">
				</div>
			</div>
			<div class="layui-form-item">
				<label class="layui-form-label">{{types == 1 ? '登录密码': '新密码'}}</label>
				<div class="layui-input-block">
					<input v-if="types==1" type="password" name="password1" required lay-reqText="请输入登录密码" lay-verify="required" placeholder="请输入登录密码" autocomplete="off" class="layui-input">
					<input v-if="types==2" type="password" name="password1" required lay-reqText="请输入新的登录密码" lay-verify="required" placeholder="请输入新的登录密码" autocomplete="off" class="layui-input">
				</div>
			</div>
			<div class="layui-form-item">
				<label class="layui-form-label">确认密码</label>
				<div class="layui-input-block">
					<input type="password" name="password2" required lay-reqText="请再次输入登录密码" lay-verify="required" placeholder="请再次输入登录密码" autocomplete="off" class="layui-input">
				</div>
			</div>
			<div class="layui-form-item">
				<label class="layui-form-label">验&nbsp;&nbsp;证&nbsp;&nbsp;码</label>
				<div class="layui-input-block f_row al_itm">
					<input type="text" name="codes" required lay-reqText="请输入短信验证码" lay-verify="required" placeholder="请输入短信验证码" autocomplete="off" class="layui-input">

					<div @click="getQcode" class="layui-form-mid sendCode pointer zt_color" style="line-height: 27px;">{{coding? times+'S后重试' : '获取'}}</div>
				</div>
			</div>
			<div class="layui-form-item f_row al_itm" v-if="types==1">
				<label class="layui-form-label"></label>
				<div class="layui-input-block f_row al_itm" style="margin-left:20px;">
					<i v-show="checkIt" class="layui-icon-radio layui-icon zt_txt_color pointer" style="font-size: 22px;line-height: 32px;margin-top: 2px;" @click="onRadios"></i>
					<i v-show="!checkIt" class="layui-icon-circle layui-icon color_80 pointer" style="font-size: 22px;line-height: 32px;margin-top: 2px;" @click="onRadios"></i>
					<span style="line-height: 32px;margin-left: 10px;">我已阅读并同意</span>
					<span @click="showXyis" style="color:#FF9800;line-height: 32px;" class="pointer">《服务条款》</span>
					<span @click="showXyis" style="color:#FF9800;line-height: 32px;" class="pointer">《保密协议》</span>
				</div>
			</div>
			<div class="layui-form-item">
				<label class="layui-form-label"></label>
				<div class="layui-input-block">
					<button class="layui-btn nextBtns pointer zt_color" lay-submit lay-filter="logins">下一步</button>
					<div class="f_row al_itm jc_end color_70" style="margin-top:10px;">
						<span @click="loginIt" class="pointer d_line">直接登录</span>
					</div>
				</div>
			</div>
		</div>
		<el-dialog title="《桃琼之瑶SMT活动钢网线上交易平台服务条款》" :visible.sync="showXyi" width="60%" :modal="false" :close-on-click-modal='false' :close-on-press-escape='false' center>
			<div v-if="showXyi" style="height: 500px;overflow: auto;" v-html="content"></div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="showXyi = false">取 消</el-button>
				<el-button type="primary" @click="onConsent">下一步</el-button>
			</div>
		</el-dialog>
		<el-dialog title="《桃琼之瑶SMT活动钢网线上交易平台保密协议》" :visible.sync="showXyi2" width="60%" :modal="false" :close-on-click-modal='false' :close-on-press-escape='false' center>
			<div v-if="showXyi2" style="height: 500px;overflow: auto;" v-html="content2"></div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="showXyi2 = false">取 消</el-button>
				<el-button type="primary" @click="onConsent2">我已阅读并同意</el-button>
			</div>
		</el-dialog>
		<div class="layui-footer align_center zt_color f_row al_itm jc_ct" style="left:0;color:#fff;">
			<span>© 桃琼之瑶SMT活动钢网</span>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'login',
		data() {
			return {
				showXyi: false,
				checkIt: false,
				forms: '',
				types: 1,
				phones: "",
				times: 60,
				coding: false,
				returnPhone: '',
				returnCode: '',
				content: '',
				content2: '',
				showXyi2: false,
			}
		},
		created() {
			let _this = this;
			api.qySecrecy({ //保密协议

			}).then((res) => {
				_this.content2 = res.data.content;
			});
			api.gcsSecrecy({ //服务条款

			}).then((res) => {
				_this.content = res.data.content;
			});
		},
		mounted() {
			let that = this;
			this.types = this.$route.query.types;
			layui.use(['form', 'layer', 'element'], () => {
				this.forms = layui.form;
				const layer = layui.layer;
				var element = layui.element;
				this.forms.on('submit(logins)', (e) => {
					if(e.field.password1 != e.field.password2) {
						layer.msg('两次输入的密码不一致', {
							icon: 2,
							anim: 6
						});
						return;
					} else {
						if(!this.checkIt && this.types == 1) {
							layer.msg('请阅读并同意服务条款', {
								icon: 2,
								anim: 6
							})
							return false;
						}
						if(this.types == 1) {
							api.register({ //注册
								phone: e.field.phones,
								code: e.field.codes,
								password: e.field.password1,
								repassword: e.field.password2
							}).then((res) => {
								if(res.code == 1) {
									let token = res.data.token;
									that.setCookie('token', token);
									this.$router.replace('improving');
								} else {
									layer.msg(res.msg, {
										icon: 2,
										anim: 6
									})
								}
							})
						} else {
							that.delCookie('token');
							api.forgetPwd({ //忘记密码
								phone: e.field.phones,
								code: e.field.codes,
								password: e.field.password1,
								repassword: e.field.password2
							}).then((res) => {
								if(res.code == 1) {
									layer.msg('修改成功', {
										icon: 1,
										anim: 0
									})
									this.$router.replace('login');
								} else {
									layer.msg(res.msg, {
										icon: 2,
										anim: 6
									})
								}
							})
						}
					}
				});
				this.forms.render();
			});
		},
		methods: {
			getQcode() { //获取验证码
				if(this.phones == "") {
					layer.msg('请输入手机号', {
						icon: 2,
						anim: 6
					});
					return false;
				}
				if(!this.coding) {
					api.getCodes({
						phone: this.phones,
						type: 1,
						use: this.types
					}).then((res) => {
						if(res.code == 1) {
							this.coding = true;
							var jshiq = setInterval(() => {
								if(this.times >= 1) {
									this.times--;
								} else {
									clearInterval(jshiq);
									this.coding = false;
									this.times = 60;
								}
							}, 1000)
						} else if(res.code == 0) {
							layer.msg(res.msg, {
								icon: 2,
								anim: 6
							})
						}
					})
				} else {
					return false;
				}
			},
			loginIt() { //直接登录
				this.$router.replace('login')
			},
			showXyis() { //服务条款
				this.showXyi = true;
			},
			onRadios() {
				if(!this.checkIt) {
					this.showXyi = true;
				} else {
					this.checkIt = false;
				}
			},
			onConsent() {
				this.showXyi = false;
				this.showXyi2 = true;
			},
			onConsent2() {
				this.checkIt = true;
				this.showXyi2 = false;
			},
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.logo {
		text-align: center;
		margin: 50px auto;
	}
	
	.logo img {
		width: 200px;
	}
	
	.rgBoxs {
		width: 600px;
		font-size: 16px;
		margin: 50px auto;
	}
	
	.rgBoxs input {
		width: 100%;
		line-height: 45px;
		height: 45px;
		color: rgba(136, 136, 136, 1);
		text-align: left;
		font-family: Microsoft Yahei;
		border: 1px solid rgba(187, 187, 187, 1);
	}
	
	.rgBoxs .sendCode {
		font-size: 16px;
		width: 106px;
		margin: 0 0 0 30px;
		text-align: center;
		border-radius: 0px;
		color: #fff;
	}
	
	.rgBoxs .nextBtns {
		width: 100%;
		line-height: 40px;
		border-radius: 0px;
		color: rgba(255, 255, 255, 1);
		font-size: 18px;
		text-align: center;
		font-family: SourceHanSansSC;
	}
	
	.tkuan {
		font-family: SourceHanSansSC;
		position: fixed;
		background: #fff;
		padding: 0 30px;
		box-sizing: border-box;
		left: 20%;
		top: 7.5%;
		width: 60%;
		height: 85%;
	}
	
	.tkuan .titles {
		font-size: 20px;
		padding: 10px 0;
	}
	
	.tkuan textarea {
		width: 100%;
		border: none;
		font-size: 16px;
		background: #fff;
		height: 100%;
		resize: none;
		overflow-y: scroll;
	}
	
	.oks {
		width: 30%;
		background: #4876FF;
		color: #fff;
		line-height: 35px;
		text-align: center;
		font-size: 16px;
		border-radius: 0px;
		margin: 4px auto 8px;
	}
</style>


// WEBPACK FOOTER //
// src/components/register.vue